import { AdminApi, ApiAdminSetNewSubscriptionLevelPostRequest, ApiAdminSetUserAsAdminPostRequest, WebApiAdminDtoSetSubscriptionDto, WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";
import { DashboardService } from "./DashboardService";

export abstract class AdminService {
    public static GetAllUsers = async () => {
        return new AdminApi(GetApiConfiguration()).apiAdminGetAllUsersGet();
    };

    public static SetUserAsAdmin = async (userId: number) => {
        const body: ApiAdminSetUserAsAdminPostRequest = { body: userId };
        return new AdminApi(GetApiConfiguration()).apiAdminSetUserAsAdminPost(body);
    };

    public static DeleteAllCompanyMembers = async (companyId: number) => {
        return new AdminApi(GetApiConfiguration()).apiAdminDeleteAllMembersDelete({ companyId: companyId });
    };

    public static DeleteAllMemberFields = async (companyId: number) => {
        return new AdminApi(GetApiConfiguration()).apiAdminDeleteAllMemberFieldsDelete({ companyId: companyId });
    };

    public static SetSubscription = async (companyId: number, subscription: WebApiAdminDtoSetSubscriptionDto) => {
        const body: ApiAdminSetNewSubscriptionLevelPostRequest = { webApiAdminDtoSetSubscriptionDto: subscription, companyId: companyId };
        return new AdminApi(GetApiConfiguration()).apiAdminSetNewSubscriptionLevelPost(body);
    };

    public static GetDashboard = async () => {
        return new AdminApi(GetApiConfiguration()).apiAdminDashboardGet();
    };

    public static UpdateTenant = async (request: WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest) => {
        return new AdminApi(GetApiConfiguration()).apiAdminUpdateTenantPut({
            webApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest: request,
        });
    };
}